import React from 'react';
import { Stack } from '@mui/material';
import ApplicationStatusFlow from './ApplicationStatusFlow';
var ApplicationHeader = function (_a) {
    var applicationId = _a.applicationId, customerName = _a.customerName, customerCode = _a.customerCode, statusSteps = _a.statusSteps;
    var displayCode = customerCode || applicationId;
    return (React.createElement(Stack, { spacing: 0.75, sx: { minWidth: 0, flex: 1 } },
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1, sx: { minWidth: 0 } },
            React.createElement(Stack, { spacing: 0.5, sx: { minWidth: 0 } },
                React.createElement(ApplicationStatusFlow, { steps: statusSteps, compact: true })))));
};
export default ApplicationHeader;
